<template>
  <div class="about-us-area pb-100">
    <div class="container">
      <div class="section-title mw-860">
        <span class="top-title">متعة ترفيهية يومية</span>
        <h2>تابع كل ما تحبه يومياً بأعلى جودة وثبات</h2>
      </div>

      <div class="row align-items-center">
        <div class="col-lg-6 col-xxl-7">
          <div class="about-img">
            <img src="@/assets/images/about.jpg" alt="about" />
            <div class="affordable">
              <h4>باقات مميزة وموفرة تبدأ من</h4>
              <h2>10 يورو</h2>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xxl-5">
          <div class="about-content">
            <div class="accordion style-two">
              <div
                class="accordion-item"
                v-for="(item, index) in accordionItems"
                :key="index"
                :class="{ active: activeIndex === index }"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button pt-0"
                    type="button"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="toggleAccordion(index)"
                  >
                    {{ item.title }}
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse show"
                  v-show="activeIndex === index"
                >
                  <div class="accordion-body">
                    <p>
                      {{ item.body }}
                    </p>
                    <ul class="ps-0 list-unstyled about-list">
                      <li
                        v-for="(listItem, i) in item.list"
                        :key="i"
                        class="d-flex align-items-center"
                      >
                        <i class="ti ti-circle-check"></i>
                        <span>{{ listItem }}</span>
                      </li>
                    </ul>

                    <RouterLink to="/pricing-plan" class="btn">
                      <span class="border-style">تصفح باقات الاشتراك</span>
                    </RouterLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PoweringDailyLife",
  setup() {
    const activeIndex = ref<number>(0);

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    const accordionItems = [
      {
        title: "جميع القنوات العربية والعالمية في مكان واحد",
        body: "نوفر للمغتربين في ألمانيا وكافة الدول الأوروبية وصولاً كاملاً لقروبات القنوات المشفرة والمفتوحة (رياضية، ترفيهية، وإخبارية) بجودة عالية.",
        list: [
          "تحديثات مستمرة ومنتظمة لقروبات القنوات",
          "جودات متعددة (4K, FHD, HD, SD) تناسب سرعات الإنترنت",
          "قنوات مخصصة للأطفال ومحتوى عائلي آمن",
        ],
      },
      {
        title: "تغطية كاملة وشاملة للمباريات والبطولات الكبرى",
        body: "لا تفوت أي لحظة من الإثارة؛ سيرفراتنا مهيأة وموزعة في أوروبا لضمان بث ثابت بدون تقطيع أثناء المنافسات الرياضية الكبرى والدوريات العالمية.",
        list: [
          "ثبات مطلق ومقاومة عالية للحظر وضغط المباريات",
          "قنوات رياضية متعددة اللغات والجودات",
          "تنبيهات وإضافات مستمرة لأبرز الأحداث الرياضية",
        ],
      },
      {
        title: "أضخم مكتبة أفلام ومسلسلات (VOD) متجددة",
        body: "استمتع بمشاهدة أحدث إنتاجات السينما العالمية والعربية، والمسلسلات الحصرية (نتفليكس، شاهد، وغيرها) مع ترجمة واضحة واحترافية.",
        list: [
          "آلاف الأفلام والمسلسلات بجودة عالية",
          "إمكانية طلب إضافة الأفلام والمسلسلات المفضلة",
          "تقسيم ذكي ومنظم يسهل عملية البحث والوصول",
        ],
      },
      {
        title: "سهولة التشغيل والتوافق مع جميع أجهزتك",
        body: "سواء كنت تملك شاشة ذكية، هاتفاً محملاً، جهاز تابلت، أو ريسيفر أندرويد؛ سنوفر لك التطبيق المناسب وطريقة التفعيل السريعة خلال دقائق.",
        list: [
          "دعم كامل لتطبيقات IPTV الشهيرة",
          "تفعيل فوري وآمن مباشرة بعد الدفع",
          "مساعدة خطوة بخطوة من فريق الدعم الفني",
        ],
      },
    ];

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>